import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CompareFareService {
	protected _pack: any[];

	protected constructor(
	) { }


	get pack(): any { return this._pack; }
	set pack(value: any) { this._pack = value; }

}
